import auth from "../../utils/auth"
import Axios from "axios"
import account from '../../database/account.json'
import { errorHandler } from "../../utils"
import api from '../../api'
import adapter from "./adapter"
import { TIMEOUT } from "../../constants"

const { getTokenFromLocalStorage } = auth()

function generateHeaders(){
  const token = getTokenFromLocalStorage()
  return token === null ? {
    'X-Api-Key': api.key
  } : {
    'X-Api-Key': api.key,
    'Authorization': `JWT ${token}`
  }
}

const accountService = {
  /**
   * GET - current logged in account data
   */
  async getAccount(){
    const token = getTokenFromLocalStorage()
    const config = {
      timeout: TIMEOUT,
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `JWT ${token}`
      }
    }

    return new Promise(function(resolve, reject){
      if(token === 'dev'){
        const type = prompt('account type')
        if(type === '1' || type === '2') account.accountType.id = parseInt(type)

        resolve(account)
      } else {
        Axios.get(api.base+api.account, config)
        .then(res => {
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      }
    })
  },

  /**
   * POST - create new account
   */
  async createAccount(data, typeAccount){
    console.log('match this structure:', data)

    return new Promise(function(resolve, reject){
      let requestBody = (
        typeAccount === 1 ? matchIndividuAccount(data) :
        typeAccount === 2 ? adapter.organization.formToRequestBody(data) :
        reject()
      )
      console.log('requestBody', requestBody)

      /* Axios */
      Axios.post(api.base+api.account_create, requestBody)
      .then(res => {
        console.log(res)
        if(res.data){
          resolve(res.data)
        }else{
          resolve(res)
        }
      })
      .catch(err => {
        const message = errorHandler(err)
        reject(message)
      });
      // resolve()
    })
  },

  /**
   * PUT - update individu
   */
  async updateIndividu(data, typeAccount){
    console.log('match this structure:', data)

    return new Promise(function(resolve, reject){
      if(typeAccount === 1){
        let requestBody = matchIndividu(data)
        console.log('requestBody', requestBody)

        const token = getTokenFromLocalStorage()
        const config = {
          headers: {
            'X-Api-Key': api.key,
            'Authorization': `JWT ${token}`
          }
        }

        if(data.userId){
          /* Axios */
          Axios.put(`${api.base}${api.individu_update}${data.userId}/`, requestBody, config)
          .then(res => {
            console.log(res)
            if(res.data){
              resolve(res.data)
            }else{
              resolve(res)
            }
          })
          .catch(err => {
            const message = errorHandler(err)
            reject(message)
          });
          // resolve()
        } else {
          reject('userId not provided.')
        }
      } else {
        reject('Invalid typeAcount.')
      }
    })
  },

  /**
   * PUT - update individu image
   */
  async updateIndividuImage(data){
    return new Promise(function(resolve, reject){
      let requestBody = data.formData
      console.log('requestBody', requestBody)

      const token = getTokenFromLocalStorage()
      const config = {
        headers: {
          'X-Api-Key': api.key,
          'Authorization': `JWT ${token}`
        }
      }

      if(data.userId){
        /* Axios */
        Axios.put(`${api.base}${api.individu_update}${data.userId}/`, requestBody, config)
        .then(res => {
          console.log(res)
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
        // resolve()
      } else {
        reject('userId not provided.')
      }
    })
  },

  /**
   * DELETE
   */
  async delete(id){
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateHeaders()
      }

      if(id){
        Axios.delete(`${api.base}${api.account}${id}/`, config)
        .then(res => {
          console.log(res)
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },
}

// eslint-disable-next-line
function subAdapter(key, data, dataOnDatabase){
  const linksOnDatabase = dataOnDatabase.map(d => d.link)

  let result

  if(key === 'social'){
    const socialLinks = Object.keys(data).map(k => {
      if(k.includes('link_')){
        return {
          kategoriSosialMedia: parseInt(k.split('link_')[1]),
          linkSosialMedia: data[k],
        }
      }
      return false
    })

    const filtered = socialLinks.filter(s => s.linkSosialMedia ? s.linkSosialMedia.length > 0 : s !== false)
    const filtered1 = filtered.filter(s => s.linkSosialMedia !== "")
    const filtered2 = filtered1.filter(s => !linksOnDatabase.includes(s.linkSosialMedia))

    result = filtered2
  }

  console.log('account service adapter result:', result)

  return result
}

function matchIndividu(data){
  console.log('matchIndividu data:', data)
  const { socialLinks: socialLinksOnDatabase } = data

  const finalData = {
    namaIndividu: data.name,
    // imgFotoProfile: "/assets/image.png",
    institusi: data.institution,
    tentangSaya: data.content,
    email: data.email,
    telepon: data.phone,
    // invitedByOrganizations: 2,
    pekerjaan: typeof data.occupation === 'string' ? data.occupation : data.occupation?.value,
    statusIndividu: data.status,
    sosialMedia: subAdapter('social', data, socialLinksOnDatabase)
    // sosialMedia: [
    //   {
    //     kategoriSosialMedia: 1,
    //     linkSosialMedia: "https://twitter.com/twitternya",
    //   },
    //   {
    //     kategoriSosialMedia: 2,
    //     linkSosialMedia: "https://instagram.com/instagramnya",
    //   },
    // ],
    // userAccess: [{ organisasiId: 3, typeUsergoup: 10 }],
    // joinRequest: [
    //   {
    //     joinAttachment: "https://khub.com/register?a=1234",
    //     organisasiYangDirequest: 0,
    //     statusRequest: 1,
    //   },
    // ],
    // joinedOrganization: [{ organisasiId: 1, namaOrganisasi: "Pixelpi" }],
    // vsbNamaIndividu: 1,
    // vsbFotoProfile: 1,
    // vsbPekerjaan: 1,
    // vsbInstitusi: 1,
    // vsbTentangSaya: 1,
    // vsbEmail: 1,
    // vsbTelepon: 1,
    // vsbInvitedByOrganizations: 1,
    // vsbSosialMedia: 1,
    // vsbGender: 1,
    // vsbDifable: 1,
  }

  // Handle gender
  if(data.gender && data.gender.value){
    finalData.typeGender = data.gender.value
  }

  // Handle disability field
  if(data.disability){
    if(data.disability.value === 0){
      finalData.typeDifable = "0"
    } else {
      finalData.typeDifable = data.disability.value
    }
  }

  return finalData
}

function matchIndividuAccount(data){
  const nameFallback = data.email ? data.email.split('@')[0] : false
  const name = data.name ? data.name : nameFallback

  return {
    email: data.email,
    password: data.password,
    telepon: data.phone,
    typeAccount: 1,
    individu: [
      { namaIndividu: name }
    ]
  }
}

export default accountService
